<template>
  <div id="staff-list">
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }}</h2>
        <v-row no-gutters justify="end" class="mb-4">
          <v-col cols="auto">
            <v-btn
              v-if="refreshButtonFlag"
              elevation="6"
              shaped
              tile
              small
              color="#9370d8"
              class="white--text mr-2"
              @click.prevent="refreshPageData"
            >
              Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <h4>{{ PageDescription }}</h4>
      </v-card-subtitle>
      <v-dialog v-model="addRecordPrompt" persistent max-width="600px">
        <add-nomination-online-payment
          pageDescription="Add Nomination Online Payment"
          :addRecordPrompt="addRecordPrompt"
          @hideAddRecordPrompt="hideAddRecordPrompt"
          v-if="addRecordPrompt"
        ></add-nomination-online-payment>
      </v-dialog>
      <v-card-text>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-row wrap>
          <v-col cols="12" sm="6" lg="3" md="3">
            <label
              ><h6><b>From Date</b></h6></label
            >
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  required
                  v-model="FromDate"
                  label="From Date"
                  readonly
                  v-on="on"
                  background-color="#F3F6F9"
                  class="form-control form-control-lg form-control-solid"
                  validate-on-blur
                  solo
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="FromDate"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" lg="3" md="3">
            <label
              ><h6><b>To Date</b></h6></label
            >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  required
                  v-model="ToDate"
                  label="To Date"
                  readonly
                  v-on="on"
                  background-color="#F3F6F9"
                  class="form-control form-control-lg form-control-solid"
                  validate-on-blur
                  solo
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="ToDate"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" lg="3" md="3">
            <h6>Payment Id <small>(optional)</small></h6>
            <v-text-field
              v-model="PaymentId"
              :rules="PaymentIdRules"
              placeholder="Payment Id"
              hint="Enter razorpay payment id"
              persistent-hint
              required
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" lg="3" md="3">
            <label>
              <h6><b>Zone</b> <small> (optional)</small></h6>
            </label>
            <v-autocomplete
              :reduce="(option) => option.value"
              v-model="ZoneCode"
              :rules="ZoneCodeRules"
              :items="ZoneCodeOptions"
              :loading="ZoneCodeOptionsLoading"
              dense
              clearable
              required
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" lg="3" md="3">
            <label>
              <h6><b>LO</b> <small> (optional)</small></h6>
            </label>
            <v-autocomplete
              :reduce="(option) => option.value"
              v-model="LomCode"
              :rules="LomCodeRules"
              :items="LomCodeOptions"
              :loading="LomCodeOptionsLoading"
              dense
              clearable
              required
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <label>
              <h6><b>Designation</b> <small> (optional)</small></h6>
            </label>
            <v-autocomplete
              :reduce="(option) => option.value"
              :items="NominationDesignationOptions"
              :rules="NominationDesignationRules"
              :loading="NominationDesignationOptionsLoading"
              v-model="NominationDesignation"
              :item-value="'value'"
              :item-text="'text'"
              hint="Select a nomination designation"
              persistent-hin
              dense
              clearable
              required
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" lg="3" md="3" class="d-flex align-center">
            <v-btn
              color="primary"
              class="white--text"
              @click="getTableRecords"
              :loading="SearchFlag"
            >
              Search
            </v-btn>
          </v-col>
        </v-row>
        <v-container class="py-0">
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-btn
                v-if="RoleId == 2"
                @click.prevent="addRecordPrompt = true"
                color="#8b008b"
                elevation="30"
                shaped
                tile
                large
                class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 white--text"
              >
                Add Online Payment
              </v-btn>
              <h3 class="text-primary">{{ rows.length }} records found.</h3>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search records here"
                single-line
                hide-details
              ></v-text-field>
              <br />
              <v-data-table
                class="elevation-1 styled-table"
                v-model="selected1"
                :search="search"
                :item-key="tableOptions1.ItemKey"
                :single-select="tableOptions1.SingleSelectFlag"
                :headers="tableColumns1"
                :items="rows"
                :items-per-page="tableOptions1.ItemsPerPage"
                :footer-props="tableOptions1.FooterProps"
              >
                <template v-slot:[`item.StatusTxt`]="{ item }">
                  <v-chip
                    dark
                    :text-color="item.StatusTxt"
                    :color="item.StatusTxtColor"
                  >
                    {{ item.StatusTxt }}
                  </v-chip>
                </template>

                <template v-slot:[`item.VerifyStatusTxt`]="{ item }">
                  <v-chip
                    dark
                    :text-color="item.VerifyStatusTxt"
                    :color="item.VerifyStatusTxtColor"
                  >
                    {{ item.VerifyStatusTxt }}
                  </v-chip>
                </template>
                <template v-slot:[`item.PresidentStatusTxt`]="{ item }">
                  <v-chip
                    dark
                    :text-color="item.PresidentStatusTxt"
                    :color="item.PresidentStatusTxtColor"
                  >
                    {{ item.PresidentStatusTxt }}
                  </v-chip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom v-if="item.PreviewFlag">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        icon
                        size="25px"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="previewData(item)"
                      >
                        mdi-eye
                      </v-icon>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.MemberImage`]="{ item }">
                  <img width="100" height="100" :src="item.MemberImage" />
                </template>
                <template v-slot:[`item.ApplicationPath`]="{ item }">
                  <a
                    :href="item.ApplicationPath"
                    target="_blank"
                    class="text-decoration text-primary"
                  >
                    View Document
                  </a>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        <br /><br />
      </v-card-text>
    </v-card>
    <v-dialog v-model="previewRecordPrompt" max-width="75%">
      <nomination-preview
        pageDescription=" Nomination Details"
        :showDialog="previewRecordPrompt"
        @hideDialog="hidePreviewRecordPrompt($event)"
        :row="selectedData"
        v-if="previewRecordPrompt"
      ></nomination-preview>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import NominationPreview from "@/view/pages/erp/events/nomination/NominationPreview.vue";
import AddNominationOnlinePayment from "@/view/pages/erp/events/nominate-member/AddNominationOnlinePayment.vue";

export default {
  mixins: [common],
  components: {
    NominationPreview,
    AddNominationOnlinePayment,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: 0,

      refreshButtonFlag: true,
      floatButtonFlag: false,
      selected1: "",
      rows: [],
      tableColumns1: [],
      tableOptions1: {},
      selected: [],
      search: "",
      CurrentYearId: 0,
      previewRecordPrompt: false,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      editRecordPrompt: false,

      editFlag: false,

      selectedData: {},
      addRecordPrompt: false,

      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],

      LoadingFlag: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      PaymentId: "",
      PaymentIdRules: [],

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      NominationDesignationOptions: [],
      NominationDesignationRules: [],
      NominationDesignationOptionsLoading: false,
      NominationDesignation: "",
      RoleId: "",
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      // this.getRegionCodeOptions();
      this.LomCode = "";
      this.getLomCodeOptions();
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LoadingFlag = false;
      this.LomCodeOptionsLoading = false;
    },
    NominationDesignation: function () {
      console.log("watch NominationDesignation");
      this.NominationDesignationLoading = false;
      var temp_code = this.NominationDesignation;
      console.log({ temp_code });
    },
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var PagePermissionFlag = tr.PagePermissionFlag;
        console.log({ PagePermissionFlag });

        if (!PagePermissionFlag) {
          this.$router.push("/access-denied");
        }

        var PagePermissionTxt = tr.PagePermissionTxt;
        console.log({ PagePermissionTxt });

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        // this.LomCode = LomId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        // RoleId = 4;
        this.RoleId = RoleId;

        this.pageData();
      }
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "nomination",
        Action: "list_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      // this.getTableRecords();
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.previewRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    pageData() {
      console.log("pageData called");
      this.getZoneCodeOptions();
      this.getNominationDesignationOptions();
    },
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log(flag);
      if (flag) {
        this.getTableRecords();
      }
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      // console.log(flag);
      // if (flag) {
      this.getTableRecords();
      // }
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },
    getNominationDesignationOptions() {
      console.log("getNominationDesignationOptions called");
      const selectbox1_source = "NominationDesignation";
      const selectbox1_destination = "NominationDesignationOptions"; // must match autocomplete items
      const selectbox1_url = "api/nomination-designation/options";
      const selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      var areaCode = this.AreaCode;
      console.log("yearCode=" + yearCode + ", areaCode=" + areaCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      console.log(
        "YearCode=" +
          YearCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode
      );
      if (YearCode != "" && ZoneCode != "") {
        this.LoadingFlag = true;
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nomination-member/lists";
      var upload = {
        UserInterface: 2,
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        PaymentId: this.PaymentId,
        Zone: this.ZoneCode,
        Lom: this.LomCode,
        Designation: this.NominationDesignation,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.rows = [];
      this.SearchFlag = true;

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SearchFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.rows = records.TableData;
            thisIns.tableColumns1 = records.TableHeader;
            thisIns.tableOptions1 = records.TableOptions;
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SearchFlag = true;
          // thisIns.toast("error", error);
        });
    },
    deleteConfirmAlert(tr) {
      console.log("deleteConfirmAlert called");
      var message = "";
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "<br/> Member Name <b> " + tr.MemberName + "</b>";
        htmlTxt += "<br/> Designation Name  <b> " + tr.DesignationName + "</b>";

        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteData(tr.NominationMember);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        if (n1 == 0) {
          message += "Kindly select one record to delete. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    deleteData(NominationMember) {
      console.log("deleteData is called");

      console.log("NominationMember=" + NominationMember);

      if (NominationMember > 0) {
        this.DeleteLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/nomination-member/destroy";
        var upload = {
          UserInterface: 1,
          NominationMember: NominationMember,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.DeleteLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.getTableRecords();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
            thisIns.DeleteLoadingFlag = false;
          });
      } else {
        var message = "Nomination Member Id should not be empty. ";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    var todayDate = new Date().toISOString().slice(0, 10);
    console.log(todayDate);

    this.FromDate = todayDate;
    this.ToDate = todayDate;
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* This is for documentation purposes and will not be needed in your application */

#staff-list {
  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }
}
</style>